import { GpmPayConfigError } from '../../core/errors.js';
import type { TransactionType } from '../../types/enums.js';
import { enumArg, intArg } from '../args.js';
import { clientFromFlags, type GlobalFlags } from '../context.js';
import { printJson } from '../redact.js';
import { EXIT, money, out, relativeTime, style } from '../ui.js';

const TYPES: readonly TransactionType[] = ['IN', 'OUT'];

export interface TransactionFlags extends GlobalFlags {
  limit?: string | undefined;
  account?: string | undefined;
  type?: string | undefined;
}

export async function transactionsCommand(
  subcommand: string | undefined,
  flags: TransactionFlags,
): Promise<number> {
  if (subcommand !== 'list') {
    throw new GpmPayConfigError(
      `Unknown subcommand "transactions ${subcommand ?? ''}". Expected: list.`,
      'invalid_argument',
    );
  }

  const client = clientFromFlags(flags);
  const limit = intArg(flags.limit, 'limit');
  const type = enumArg(flags.type, 'type', TYPES);

  const page = await client.transactions.list({
    ...(limit === undefined ? {} : { limit }),
    ...(flags.account === undefined ? {} : { bankAccountId: flags.account }),
    ...(type === undefined ? {} : { type }),
  });

  if (flags.json === true) {
    printJson(page);
    return EXIT.OK;
  }

  if (page.data.length === 0) {
    out(style.dim('No transactions found.'));
    return EXIT.OK;
  }

  for (const txn of page.data) {
    const direction = txn.type === 'IN' ? style.green('IN ') : style.red('OUT');
    out(
      `${direction} ${money(txn.amount).padStart(14)}  ${style.dim(
        relativeTime(txn.transactionTime).padEnd(14),
      )} ${txn.transferContent.slice(0, 48)}`,
    );
  }

  out(
    style.dim(
      `\n  ${String(page.data.length)} of ${String(page.meta.totalItems)} transaction(s)` +
        ` — page ${String(page.meta.page)}/${String(page.meta.totalPages)}`,
    ),
  );
  return EXIT.OK;
}
